import React, { useState, useLayoutEffect, useRef } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

import usePreviousValue from 'src/hooks/usePreviousValue';
import Icon from 'src/components/Icon/Icon';

interface OutcomeProps {
  onClick?: (e: any) => void, // eslint-disable-line
  value: string | number,
  el: any,
  isSuspended?: boolean,
  className?: string,
  children?: React.ReactNode | React.ReactNode[],
  arrowClassName?: string
}

function Outcome({ value = 0, el = 'div', isSuspended, className, onClick, children }: OutcomeProps) {
  const elRef = useRef(null);
  const [smallText, setSmallText] = useState(false);
  const prevValue = usePreviousValue(value);

  const Element: React.ElementType = el;

  useLayoutEffect(() => {
    let resizeObs: ResizeObserver;
    const elRefCurrent = elRef.current;

    if (elRef) {
      resizeObs = new ResizeObserver(() => {
        if (elRefCurrent && elRefCurrent.scrollHeight > elRefCurrent.clientHeight) {
          setSmallText(true);
        } else if (
          smallText === true && (
            (elRefCurrent && (elRefCurrent.scrollHeight !== elRefCurrent.clientHeight)) ||
            value !== prevValue
          )
        ) {
          setSmallText(false);
        }
      });

      resizeObs.observe(elRefCurrent);
    }

    return () => {
      if (elRefCurrent) {
        resizeObs.unobserve(elRefCurrent);
      }
    };
  }, [value]);

  return (
    <Element
      ref={ elRef }
      className={ className }
      onClick={ onClick }
      style={ smallText ? { fontSize: '74%' } : { fontSize: '100%' } }
    >
      { className.includes('increased') && <span className="event-row__arrow event-row__arrow--increased" /> }
      { className.includes('decreased') && <span className="event-row__arrow event-row__arrow--decreased" /> }
      { children }
      { isSuspended && <Icon icon="padlock" className="event-row__event-odds--icon" /> }
      { value }
    </Element>
  );
}

export default React.memo(Outcome);
